import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';

/** 模块状态 */
export default class ModulesState extends ModulesStateBasic {
    detailData: any;
    detailDataIn: boolean = false;
    listData: any;
    listPageNumber: number=1;
    listPageTotal: number;
    listFields: any;
    detailPageNumber: number=1;
    detailPageTotal: number;
    detailFields: any;
    selectedRowKeys: any = [];
    statistics: any;
}



// WEBPACK FOOTER //
// ./src/display/apps/InvoiceCompare/Modules.State.ts